import { UndergradLive } from './undergrad-live.model';
import { DisciplineSubmissionDeadline } from './disciplines-submission-deadline.model';

export enum CalendarEventType {
  TUTORSHIP,
  LIVE,
  SUBMISSION_DEADLINE,
}

export interface CalendarEvent {
  type: CalendarEventType;
  content: UndergradLive | DisciplineSubmissionDeadline;
  dueDate: Date;
}
